'use client'

import { Query } from '@/lib/generated/graphql-types'
import { GET_ALL_OCCUPATIONS } from '../queries'
import { useLazyQuery } from '@apollo/client'
import { useEffect } from 'react'

export function useOccupations() {
  const [getAllOccupations, { loading }] =
    useLazyQuery<Pick<Query, 'getAllOccupations'>>(GET_ALL_OCCUPATIONS)

  useEffect(() => {
    // get all occupations on mount
    getAllOccupations()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  async function getOccupationBySlug(slug: string) {
    const { data } = await getAllOccupations()
    return data?.getAllOccupations?.find(
      (occupation) => occupation.slug === slug,
    )
  }

  async function getOccupationByProfessionAndSpecialty(opts: {
    professionSlug: string
    specialtySlug: string
  }) {
    const { data } = await getAllOccupations()
    return data?.getAllOccupations?.find(
      (occupation) =>
        occupation.profession.slug === opts.professionSlug &&
        occupation.specialty.slug === opts.specialtySlug,
    )
  }
  return {
    getOccupationBySlug,
    getOccupationByProfessionAndSpecialty,
    loading,
  }
}
